import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';
import Error from '@/components/common/Error';

import OrderList from './components/list/OrderList';

import { useOrders } from '@/data/order';

const ListOrdersPage = () => {
  const orders = useOrders();

  if (orders.isLoading && !orders.data) {
    return <LoadingPage />;
  }

  if (orders.error) {
    return <Error error="There was an error loading orders" />;
  }

  return (
    <Card className="max-w-6xl mx-auto">
      <CardHeader>
        <div className="flex justify-between">
          <div className="space-y-1">
            <CardTitle>Orders</CardTitle>
            <CardDescription>Manage ProFound Orders.</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <OrderList />
      </CardContent>
    </Card>
  );
};

export default ListOrdersPage;
